import fetch from 'isomorphic-fetch';

import HttpServiceError from './httpServiceError';

enum HttpMethods {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Delete = 'DELETE'
}

export enum BitmovinHttpHeader {
  xApiClient = 'x-api-client',
  xApiKey = 'x-api-key',
  xOrgId = 'x-org-Id',
  xTrafficGroup = 'x-traffic-group',
  xUserId = 'x-user-id'
}

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  [BitmovinHttpHeader.xApiClient]: 'bitmovin-sales-demo-wrapper-app'
};

const checkStatus = (response: Response): Response => {
  if (response.ok) {
    return response;
  }

  throw new HttpServiceError(response);
};

const get = (url, additionalHeaders) => {
  return fetch(url, {
    method: HttpMethods.Get,
    headers: {
      ...DEFAULT_HEADERS,
      ...additionalHeaders
    }
  })
    .then(checkStatus)
    .then(response => response.json());
};

const post = (url, data, additionalHeaders) => {
  return fetch(url, {
    method: HttpMethods.Post,
    headers: {
      ...DEFAULT_HEADERS,
      ...additionalHeaders
    },
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(response => response.json());
};

const put = (url, data, additionalHeaders) => {
  return fetch(url, {
    method: HttpMethods.Put,
    headers: {
      ...DEFAULT_HEADERS,
      ...additionalHeaders
    },
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(response => response.json());
};

// tslint:disable-next-line:variable-name
const delete_ = (url, data, additionalHeaders) => {
  return fetch(url, {
    method: HttpMethods.Delete,
    headers: {
      ...DEFAULT_HEADERS,
      ...additionalHeaders
    },
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(response => response.json());
};

const extractBitmovinDataResult = (json: any) => json.data.result;

const authorizedGet = (url, apiKey, rawJsonResponse = false, additionalHeaders = {}) => {
  const headers = {
    ...additionalHeaders,
    [BitmovinHttpHeader.xApiKey]: apiKey
  };
  return get(url, headers).then(jsonResponse => {
    if (rawJsonResponse) {
      return jsonResponse;
    }
    return extractBitmovinDataResult(jsonResponse);
  });
};

const authorizedPost = (url, body, apiKey, additionalHeaders = {}) => {
  const headers = {
    ...additionalHeaders,
    [BitmovinHttpHeader.xApiKey]: apiKey
  };
  return post(url, body, headers).then(extractBitmovinDataResult);
};

const authorizedPut = (url, body, apiKey, additionalHeaders = {}) => {
  const headers = {
    ...additionalHeaders,
    [BitmovinHttpHeader.xApiKey]: apiKey
  };
  return put(url, body, headers).then(extractBitmovinDataResult);
};

const authorizedDelete = (url, body, apiKey, additionalHeaders = {}) => {
  const headers = {
    ...additionalHeaders,
    [BitmovinHttpHeader.xApiKey]: apiKey
  };
  return delete_(url, body, headers).then(extractBitmovinDataResult);
};

export interface IHttpService {
  authorizedGet(url: string, apiKey: string, rawJsonResponse: boolean, additionalHeaders: any);

  authorizedPost(url: string, body: any, apiKey: string, additionalHeaders: any);

  authorizedPut(url: string, body: any, apiKey: string, additionalHeaders: any);

  authorizedDelete(url: string, body: any, apiKey: string, additionalHeaders: any);

  get(url: string, headers: any): Promise<any>;

  post(url: string, data: any, headers: any): Promise<any>;

  put(url: string, data: any, headers: any): Promise<any>;

  delete_(url: string, data: any, headers: any): Promise<any>;
}

const httpService: IHttpService = {
  authorizedGet,
  authorizedPost,
  authorizedPut,
  authorizedDelete,
  get,
  post,
  put,
  delete_
};

export default httpService;
